import { useState, useEffect } from 'react';
import axios from 'axios';

function AdSlot({ genre, audience, state: targetState, mobile = false }) {
  const [ad, setAd] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams();
    if (genre)       params.set('genre',    genre);
    if (audience)    params.set('audience', audience);
    if (targetState) params.set('state',    targetState);

    axios.get(`/api/ads/serve?${params}`)
      .then(r => { setAd(r.data); setReady(true); })
      .catch(() => setReady(true));
  }, [genre, audience, targetState]);

  if (!ready || !ad) return null;

  const handleClick = () => {
    axios.post(`/api/ads/${ad._id}/click`).catch(() => {});
    window.open(ad.clickUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div style={{ width: '100%', margin: mobile ? '16px 0' : '0' }}>
      <div style={{ fontSize: '9px', color: '#bbb', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px', textAlign: 'right', fontFamily: 'Arial, sans-serif' }}>
        Advertisement
      </div>
      <div
        onClick={handleClick}
        style={{
          cursor: 'pointer',
          borderRadius: mobile ? '0' : '6px',
          overflow: 'hidden',
          height: mobile ? '500px' : '600px',
          position: 'relative',
          background: '#f0f0f0',
        }}
      >
        <img
          src={ad.imageUrl}
          alt={ad.altText || 'Advertisement'}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </div>
      {ad.advertiserName && (
        <div style={{ fontSize: '10px', color: '#aaa', textAlign: 'center', marginTop: '5px', fontFamily: 'Arial, sans-serif' }}>
          Sponsored by {ad.advertiserName}
        </div>
      )}
    </div>
  );
}

export default AdSlot;
